"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurgerOpen = exports.BurgerClosed = exports.LinkedSite = exports.LogoutButton = exports.LoginButton = exports.LogoutText = exports.IconContainer = exports.Image = exports.LogoContainer = exports.CartText = exports.CartTextCircle = exports.CartContainer = exports.CartIcon = exports.SearchIcon = exports.AccountContainer = exports.RegionContainer = exports.OtherTitle = exports.OtherContainer = exports.Menu = exports.Header = exports.MobileNav = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../../../Components/UI/Typography"));
const svg_components_1 = require("../../../../assets/svg-components");
const Button_1 = __importDefault(require("./../../../Button"));
const BurgerClosed_1 = require("../../../../assets/svg-components/BurgerClosed");
const BurgerOpen_1 = require("../../../../assets/svg-components/BurgerOpen");
exports.MobileNav = styled_components_1.default.nav `
  width: 100%;
  position: ${({ isTransparent }) => (isTransparent ? 'fixed' : 'sticky')};
  overflow: auto;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'block')};
  flex-direction: column;
  height: ${({ isOpen }) => (isOpen ? '100dvh' : 'auto')};
  top: 0;
  left: 0;
  z-index: ${({ theme }) => theme.attributes.zIndex.header};
  background-color: ${({ theme, isTransparent, isOpen }) => isTransparent && !isOpen ? 'transparent' : theme.palette.BW_100};
  transition: ${({ theme }) => theme.attributes.transition.fast};
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  box-shadow: ${props => (props.isScrolled ? props.theme.attributes.boxShadow.regular : 'none')};

  @media print {
    display: none;
  }
`;
exports.Header = styled_components_1.default.div `
  height: ${props => props.theme.constants.blockWidth.s25}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  box-shadow: ${props => props.isOpen && props.theme.attributes.boxShadow.regular};
  padding: 0 ${props => props.theme.spacing.s4}px;
  flex-shrink: 0;
`;
exports.Menu = styled_components_1.default.div `
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding-bottom: max(${({ theme }) => theme.spacing.m4}px, env(safe-area-inset-bottom));
  transition: ${({ theme }) => theme.attributes.transition.fast};
`;
exports.OtherContainer = styled_components_1.default.div `
  display: ${props => (props.isOpen ? 'flex' : 'none')};
  flex-direction: column;
  flex: 1 1 auto;
  background-color: ${props => props.theme.palette.LIGHT_GRAY_20};
`;
exports.OtherTitle = (0, styled_components_1.default)(Typography_1.default) `
  font-weight: ${props => props.theme.typography.weight.regular};
  margin-left: ${props => props.theme.spacing.s2}px;
`;
exports.RegionContainer = styled_components_1.default.div `
  margin: ${props => props.theme.spacing.s4}px 0 ${props => props.theme.spacing.s4}px
    ${props => props.theme.spacing.s4}px;
  display: flex;
  cursor: pointer;
`;
exports.AccountContainer = styled_components_1.default.div `
  margin: ${props => props.theme.spacing.s4}px 0 ${props => props.theme.spacing.s4}px
    ${props => props.theme.spacing.s4}px;
  display: flex;
  justify-content: space-between;
`;
exports.SearchIcon = (0, styled_components_1.default)(svg_components_1.SearchIcon) `
  margin-right: ${props => props.theme.spacing.m3}px;
  cursor: pointer;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-right: ${props => props.theme.spacing.s4}px;
  }
`;
exports.CartIcon = (0, styled_components_1.default)(svg_components_1.CartIcon) `
  margin-right: ${props => (props.$hasCartItems ? 0 : props.theme.spacing.m3)}px;
  cursor: pointer;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-right: ${props => (props.$hasCartItems ? 0 : props.theme.spacing.s4)}px;
  }
`;
exports.CartContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: ${props => props.theme.spacing.m3}px;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-right: ${props => props.theme.spacing.s4}px;
  }
`;
exports.CartTextCircle = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${props => props.theme.spacing.s1}px;
  background-color: ${props => props.theme.palette.ORANGE_100};
  width: ${props => props.isBigCircle
    ? props.theme.constants.mobileMenu.cartCircle.mb
    : props.theme.constants.mobileMenu.cartCircle.sm}px;
  height: ${props => props.isBigCircle
    ? props.theme.constants.mobileMenu.cartCircle.mb
    : props.theme.constants.mobileMenu.cartCircle.sm}px;
  border-radius: ${props => props.theme.attributes.borderRadius.lg}px;
`;
exports.CartText = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: -${props => props.theme.spacing.xs}px;
  color: ${props => props.theme.palette.BW_100};
`;
exports.LogoContainer = styled_components_1.default.div `
  height: 100%;
  display: flex;
  align-items: center;
`;
exports.Image = styled_components_1.default.img `
  height: 100%;
  cursor: pointer;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    width: ${props => props.theme.constants.blockHeight.s16}px;
  }
`;
exports.IconContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.LogoutText = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.HALDEX_BLUE};
`;
exports.LoginButton = (0, styled_components_1.default)(Button_1.default) `
  display: flex;
  padding: 0;
`;
exports.LogoutButton = (0, styled_components_1.default)(Button_1.default) `
  padding: 0 ${props => props.theme.spacing.s4}px;
`;
exports.LinkedSite = styled_components_1.default.a `
  margin-left: ${props => props.theme.spacing.m3}px;
  height: ${props => props.theme.constants.blockHeight.s14}px;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-left: ${props => props.theme.spacing.s4}px;
    padding-top: ${props => props.theme.spacing.s0}px;
    > img {
      width: ${props => props.theme.constants.blockWidth.s26}px;
    }
  }
`;
exports.BurgerClosed = (0, styled_components_1.default)(BurgerClosed_1.BurgerClosedIcon) `
  cursor: pointer;
`;
exports.BurgerOpen = (0, styled_components_1.default)(BurgerOpen_1.BurgerOpenIcon) `
  cursor: pointer;
`;
exports.default = {
    MobileNav: exports.MobileNav,
    Header: exports.Header,
    Menu: exports.Menu,
    OtherContainer: exports.OtherContainer,
    OtherTitle: exports.OtherTitle,
    SearchIcon: exports.SearchIcon,
    LogoContainer: exports.LogoContainer,
    Image: exports.Image,
    IconContainer: exports.IconContainer,
    LinkedSite: exports.LinkedSite,
    BurgerClosed: exports.BurgerClosed,
    BurgerOpen: exports.BurgerOpen
};
